export default __webpack_public_path__ + "static/media/recentItem.11e51802.png";